import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .locationName {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .travelsList {
    width: 100%;
  }

  .travelRow {
    padding-right: 40px;

    svg {
      position: absolute;
      right: 8px;
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .loading {
    display: flex;
    justify-content: center;
    padding: 16px 0;
  }

  .empty {
    padding: 24px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
  }

  .loadMore {
    display: flex;
    justify-content: center;
    margin-top: 8px;
  }
`;
